import { createBaseApi } from '../baseApi';
import { API_ENDPOINTS } from '../../../utils/config';

// Create base shared result API
const sharedResultApi = createBaseApi('sharedResultApi');

// Enhanced API with shared result endpoints
export const enhancedSharedResultApi = sharedResultApi.injectEndpoints({
  endpoints: (builder) => ({
    // Create a shared result link
    createSharedResult: builder.mutation({
      query: ({ vtoResultId }) => ({
        url: API_ENDPOINTS.SHARED_RESULT.BASE,
        method: 'POST',
        body: { vtoResultId }
      }),
      transformResponse: (response) => {
        if (response?.success) {
          return {
            shareToken: response.shareToken,
            shareUrl: response.shareUrl
          };
        }
        throw new Error(response?.message || 'Failed to create share link');
      }
    }),

    // Get shared result by token (public, no auth needed)
    getSharedResultByToken: builder.query({
      query: (token) => ({
        url: API_ENDPOINTS.SHARED_RESULT.BY_TOKEN(token),
        method: 'GET'
      }),
      transformResponse: (response) => {
        if (response?.success) {
          return {
            shareToken: response.shareToken,
            sharer: response.sharer,
            clothingItems: response.clothingItems || []
          };
        }
        return null;
      }
    }),

    // Claim shared items into the authenticated user's closet
    claimSharedResult: builder.mutation({
      query: (token) => ({
        url: API_ENDPOINTS.SHARED_RESULT.CLAIM(token),
        method: 'POST'
      }),
      invalidatesTags: ['ClosetClothes'],
      transformResponse: (response) => {
        if (response?.success) {
          return {
            sharer: response.sharer,
            claimedItems: response.claimedItems || []
          };
        }
        throw new Error(response?.message || 'Failed to claim items');
      }
    })
  })
});

export const {
  useCreateSharedResultMutation,
  useGetSharedResultByTokenQuery,
  useClaimSharedResultMutation
} = enhancedSharedResultApi;

export default enhancedSharedResultApi;
